<template>

  <section class="py-5 text-center container">
    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h1>گالری عکس تصویر</h1>
        <h3 class="fw-light">با مدیریت کامران بانکی</h3>
        <p class="lead text-muted">
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده
          از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و
          سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای
          متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه
          درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با
          نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان
          خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید
          داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به
          پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی
          سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
        </p>
        <p>
          <a href="tel:+98-912-1443023" class="btn btn-primary my-2 me-1">09121443023</a>
          <a href="tel:+98-21-66926480" class="btn btn-secondary my-2 me-1">66926480</a>
          <a href="tel:+98-21-66945024" class="btn btn-secondary my-2 me-1">66945024</a>
          <a href="tel:+98-21-66905372" class="btn btn-secondary my-2">66905372</a>
        </p>
      </div>
    </div>
  </section> 
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
